import { Empty, Spin } from 'antd';
import { Navigate, Outlet } from 'react-router-dom';
import { useCompanyCtx } from '../../../context/integrations/Company';
import Layout from '../Layout';
import Spinner from '../Spinner';

const AdminRoute = () => {
    const company = useCompanyCtx();

    if (!company.userInfo?.name) {
        return (
            <Layout sectionActive={'Admin Panel'} active="Admin Panel">
                <Spinner minHeight="400px">
                    <Empty
                        image={<Spin />}
                        description={'Waiting for user info.'}
                    />
                </Spinner>
            </Layout>
        );
    }

    if (!company.userInfo.isAdmin) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

export default AdminRoute;
